import React from "react";
import { useLocation } from "react-router-dom";
import { WHATSAPP_URL } from "./Constants";

const WhatsAppAnimation = () => {
  const location = useLocation();
  if (
    location.pathname === "/swayam-arjee-landing" ||
    location.pathname === "/map-routes" ||
    location.pathname.startsWith("/map-routes")
  ) {
    return null;
  }

  const hasStickyBar =
    location.pathname.includes("arjee") ||
    location.pathname.includes("bhog-cart");

  return (
    <div className="md:hidden">
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noreferrer noopener"
        aria-label="Chat on WhatsApp"
        className={`fixed ${
          hasStickyBar ? "bottom-36" : "bottom-28"
        } left-4 z-[60] inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#25d366] hover:scale-110 hover:shadow-lg transition-transform duration-300 shadow-md`}
      >
        <div className="absolute inset-0 rounded-full bg-[#25d366] animate-ping opacity-75"></div>

        <div className="relative z-10">
          <img src="/Images/wb.svg" alt="" width="28" height="28" />
        </div>
      </a>
    </div>
  );
};

export default WhatsAppAnimation;
